import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const DotsMoreIcon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", width: sizePx, height: sizePx, style: styles, ...rest },
        React.createElement("g", { clipPath: "url(#clip0_453_4180)" },
            React.createElement("path", { d: "M4 11C4.55228 11 5 10.5523 5 10C5 9.44772 4.55228 9 4 9C3.44772 9 3 9.44772 3 10C3 10.5523 3.44772 11 4 11Z", fill: color }),
            React.createElement("path", { d: "M10 11C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11Z", fill: color }),
            React.createElement("path", { d: "M16 11C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9C15.4477 9 15 9.44772 15 10C15 10.5523 15.4477 11 16 11Z", fill: color })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_453_4180" },
                React.createElement("rect", { width: "20", height: "20", fill: "white" })))));
};
export default DotsMoreIcon;
//# sourceMappingURL=index.js.map